import axios from 'axios';
import url from '@/url';

const authHeaders = () => ({
  'X-Authorization': localStorage.getItem('token'),
});

export const createSupportTicket = async (payload) => {
  const hasFile = payload && payload.image instanceof File;
  const body = hasFile
    ? (() => {
        const fd = new FormData();
        fd.append('ticketType', payload.ticketType);
        fd.append('title', payload.title);
        fd.append('description', payload.description);
        if (payload.source) fd.append('source', payload.source);
        fd.append('image', payload.image);
        return fd;
      })()
    : payload;

  const response = await axios.post(process.env.VUE_APP_SERVICE_URL + url.support_tickets_create, body, {
    headers: { ...authHeaders(), ...(hasFile ? { 'Content-Type': 'multipart/form-data' } : {}) },
  });
  return response.data?.result?.data;
};

export const getMySupportTickets = async ({ page = 0, size = 20 } = {}) => {
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + url.support_tickets_my,
    { headers: authHeaders(), params: { page, size } }
  );
  return response.data?.result?.data;
};

export const getSupportTicketDetails = async (ticketId) => {
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + url.support_tickets_show + String(ticketId),
    { headers: authHeaders() }
  );
  return response.data?.result?.data;
};

export const adminListSupportTickets = async ({ page = 0, size = 20, status, ticketType, tenantId } = {}) => {
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + url.support_tickets_admin_list,
    { headers: authHeaders(), params: { page, size, status, ticketType, tenantId } }
  );
  return response.data?.result?.data;
};

export const adminReplySupportTicket = async (ticketId, { message, newStatus, image } = {}) => {
  const hasFile = image instanceof File;
  const body = hasFile
    ? (() => {
        const fd = new FormData();
        fd.append('message', message);
        if (newStatus) fd.append('newStatus', newStatus);
        fd.append('image', image);
        return fd;
      })()
    : { message, newStatus };

  const response = await axios.post(
    process.env.VUE_APP_SERVICE_URL + url.support_tickets_admin_reply + String(ticketId) + '/reply',
    body,
    { headers: { ...authHeaders(), ...(hasFile ? { 'Content-Type': 'multipart/form-data' } : {}) } }
  );
  return response.data?.result?.data;
};

export const adminUpdateSupportTicketStatus = async (ticketId, status) => {
  const response = await axios.patch(
    process.env.VUE_APP_SERVICE_URL + url.support_tickets_admin_status + String(ticketId) + '/status',
    { status },
    { headers: authHeaders() }
  );
  return response.data?.result?.data;
};

export const addSupportTicketMessage = async (ticketId, { message, image } = {}) => {
  const hasFile = image instanceof File;
  const body = hasFile
    ? (() => {
        const fd = new FormData();
        fd.append('message', message || '');
        fd.append('image', image);
        return fd;
      })()
    : { message };

  const response = await axios.post(
    process.env.VUE_APP_SERVICE_URL + url.support_tickets_add_message + String(ticketId) + '/messages',
    body,
    { headers: { ...authHeaders(), ...(hasFile ? { 'Content-Type': 'multipart/form-data' } : {}) } }
  );
  return response.data?.result?.data;
};


